import $http from "../axios";

const state = {
  stockOperation: null
};

const getters = {
  stockOperation: state => {
    return state.stockOperation;
  }
};

const actions = {
  setStockOperation({ commit }, operation) {
    commit("SET_STOCK_OPERATION", operation);
  },

  makeRefill(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`make-refill`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  takeInventory(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`take-inventory`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  reportLoss(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`report-loss`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_STOCK_OPERATION(state, operation) {
    state.stockOperation = operation;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
